module.exports = __webpack_public_path__ + "img/硫磺温泉毛孔净化套_04.a089bd5f.jpg";